export const AllProject = [
  {
    id: 1,
    title: 'Koho admin Design',
    badge: 'Doing',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Koho Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '12',
    resolved: '5',
    comment: '7',
    like: '+10 More',
    progress: '70',
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 2,
    title: 'Cuba admin Design',
    badge: 'Doing',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Cuba Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '24',
    resolved: '24',
    comment: '40',
    like: '+3 More',
    progress: '100',
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 3,
    title: 'Poco admin Design',
    badge: 'Doing',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Poco Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '40',
    resolved: '40',
    comment: '20',
    like: '+2 More',
    progress: '100',
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 4,
    title: 'Cuba admin Design',
    badge: 'Doing',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Cuba Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '24',
    resolved: '24',
    comment: '40',
    like: '+3 More',
    progress: '100',
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 5,
    title: 'Roxo admin Design',
    badge: 'Doing',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Roxo Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '12',
    resolved: '5',
    comment: '7',
    like: '+10 More',
    progress: '70',
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 6,
    title: 'Xoxo admin Design',
    badge: 'Doing',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Xoxo Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '40',
    resolved: '40',
    comment: '20',
    like: '+2 More',
    progress: 100,
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 7,
    title: 'Enzo admin Design',
    badge: 'Done',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Enzo Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '12',
    resolved: '5',
    comment: '7',
    like: '+10 More',
    progress: 70,
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 8,
    title: 'Tivo admin Design',
    badge: 'Done',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Tivo Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '24',
    resolved: '24',
    comment: '40',
    like: '+3 More',
    progress: 100,
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 9,
    title: 'Poco admin Design',
    badge: 'Done',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Poco Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '40',
    resolved: '40',
    comment: '20',
    like: '+2 More',
    progress: 100,
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 10,
    title: 'Tivo admin Design',
    badge: 'Done',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Tivo Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '24',
    resolved: '24',
    comment: '40',
    like: '+3 More',
    progress: 100,
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 11,
    title: 'Koho admin Design',
    badge: 'Done',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Koho Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '12',
    resolved: '5',
    comment: '7',
    like: '+10 More',
    progress: 70,
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
  {
    id: 12,
    title: 'Xoxo admin Design',
    badge: 'Done',
    img: 'user/3.jpg',
    sites: 'Themeforest, australia',
    desc: 'Xoxo Admin is a full featured, multipurpose, premium bootstrap admin template.',
    issue: '40',
    resolved: '40',
    comment: '20',
    like: '+2 More',
    progress: 100,
    customers_img1: 'user/3.jpg',
    customers_img2: 'user/5.jpg',
    customers_img3: 'user/1.jpg',
  },
];

export const ProjectTypeSelect = [
  { value: 'Hourly', label: 'Hourly' },
  { value: 'FixPrice', label: 'Fix price' },
];
export const ProjectPrioritySelect = [
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
  { value: 'Urgent', label: 'Urgent' },
];
